import { IAM_SSO_URL, OXE_SYNC_INTERVAL, OXE_OP_URL, OXE_SYNC_URL } from "../../utils/Config"
import { CC_PRODUCT_ID, IS_POD, OXE_CLIENT_INFO, OXE_LOGIN, ROLE, SUCCESS, TBL_PAGE_SIZE, TOKEN_1, TOKEN_2 } from "../../utils/Constants"
import { getRequest, postRequest } from "../../utils/RequestActions"
import { convertRespArrToSingleObj, getBoardListCount, parseTableData, parseTableSchema } from "../../utils/SchemaParseUtils"
import { decodeToken, setLocalStorageItems, setRefreshTimeout } from "../../utils/SecurityUtils"
import { getSessionItem, removeSessionItem, setSessionItem } from "../../utils/storageUtils"
import { setContentLoading, setSelectedApplication, setDynamicPagnItemCount } from "../reducers/CommonReducer"
import { setOxeAndClientInfo, setOxeAuthStatus, setOxeLogList, setOxeLogSchema, setOxeUmcConnected, setOxeSystemConfigSchema, setOxeSystemConfigData, setOxeUmcDiscriminator } from "../reducers/OxeReducer"
import { navigateTo, getTranslated } from "../../utils/CommonUtils"
import confirmModal from "../../components/common/confirmModal";

export const getOxeState = (validateOxeState, callback) => {

    const request = {
        url: `${IAM_SSO_URL}/oxe/state?ccProductId=${getSessionItem(CC_PRODUCT_ID)}&isPod=${getSessionItem(IS_POD)}&role=${getSessionItem(ROLE)}`,
        options: { credentials: "include" },
        header: {}
    }

    return (dispatch, getState) => {
        getRequest(request, (res, status) => {
            if (status && res.token) {
                const decoded = decodeToken(res.token)
                setLocalStorageItems(decoded)
                setSessionItem(TOKEN_1, res.token)
                dispatch(setOxeUmcConnected(res.connection))

                let timer = setRefreshTimeout(decoded.exp, validateOxeState)
                // timer = timerArr.concat(timer)
                // dispatch(setTimerArr(timer))

                callback(true)
            } else {
                callback(false)
            }
        })
    }
}

export const oxeLogin = (postData, callback) => {

    const request = {
        url: `${IAM_SSO_URL}/oxe/login`,
        options: { credentials: "include" },
        header: { "Content-Type": "application/x-www-form-urlencoded", "Authorization": `Bearer ${getSessionItem(TOKEN_1)}` },
        bodyData: postData
    }
    return (dispatch, getState) => {
        postRequest(request, (res, status) => {
            if (status && res.status && res.token) {
                const decoded = decodeToken(res.token)
                let timer = setRefreshTimeout(decoded?.exp, () => oxeLoginExpireHandler(dispatch))

                setSessionItem(TOKEN_2, res.token)

                res.data && dispatch(setOxeAndClientInfo(res.data))
                dispatch(setOxeAuthStatus(true))
                refreshCacheOXEModal()
                callback(true)
            } else {
                callback(null)
            }
        })
    }
}

export const oxeLoginExpireHandler = (dispatch) => {

    // return (dispatch, getState) => {
    removeSessionItem(TOKEN_2)
    dispatch(setOxeAndClientInfo(""))
    dispatch(setOxeAuthStatus(false))
    dispatch(setSelectedApplication(OXE_LOGIN))
    navigateTo(`/${OXE_LOGIN}`)
    // }
}

export const getOxeOPTableSchema = () => {
    return (dispatch, getState) => {
        const request = {
            url: OXE_OP_URL + "/schema/list/oxeoperation"
        }

        getRequest(request, (response, status) => {
            if (status && response?.responseCode === SUCCESS) {
                const schema = parseTableSchema(response)
                dispatch(setOxeLogSchema(schema))
            } else {
                console.log(response)
            }
        })
    }
}

export const getOxeOPList = () => {
    return (dispatch, getState) => {

        const state = getState()
        const {
            pageFromIndex,
            filter,
            fieldFilter,
            dateFilter,
            sortField,
            sortType,
        } = state.common;

        let url = `${OXE_OP_URL}/data/list/oxeoperation/${getSessionItem(CC_PRODUCT_ID)}/?from=${pageFromIndex}&size=${getSessionItem(TBL_PAGE_SIZE)}`;

        // Operation based endpoints
        if (filter) url += `&filter=${encodeURIComponent(filter)}`;
        if (fieldFilter) url += `&fieldfilter=${encodeURIComponent(fieldFilter)}`;
        if (dateFilter) url += `&dateFilter=${dateFilter}`;
        if (sortField && sortType) url += `&filter=${encodeURIComponent(filter)}&sortField=${encodeURIComponent(sortField)}&sortType=${encodeURIComponent(sortType)}`;

        const request = { url };
        getRequest(request, (response, status) => {
            if (status && response?.responseCode === SUCCESS) {
                dispatch(setDynamicPagnItemCount(getBoardListCount(response)))

                const data = parseTableData(response)
                dispatch(setOxeLogList(convertRespArrToSingleObj(data)))
                dispatch(setContentLoading(false))
            } else {
                console.log(response)
                dispatch(setContentLoading(false))
            }
        })
    }
}

export const refreshCacheOXEModal = () => {
    const request = {
        url: `${OXE_SYNC_URL}/cache`
    }

    getRequest(request, (res, status) => {
        if (status) {
            // res.every(item => item.status === SUCCESS)
            setTimeout(() => {
                refreshCacheOXEModal()
            }, OXE_SYNC_INTERVAL)
        } else {
            // what if fails
        }
    })
}

export const handleOXEDisconnection = () => {
    return (dispatch, getState) => {
        dispatch(setOxeUmcConnected(false))
        dispatch(setOxeAuthStatus(false))
        dispatch(setSelectedApplication(OXE_LOGIN))
        navigateTo(`/${OXE_LOGIN}`)

        removeSessionItem(TOKEN_2)
        removeSessionItem(OXE_CLIENT_INFO)
    }
}

export const getOxeSyncSchema = (url) =>{
    return (dispatch) => {
   
        const requesturl = {
            url: `${OXE_SYNC_URL}/systemconf/schema`
           
        }

        getRequest(requesturl , (response, status) => { 
            if (status && response?.responseCode === SUCCESS) {
                dispatch(setOxeSystemConfigSchema(response))
            } else {
                console.log(response)
            }


        })

    }
}


export const getOxeSyncData = (url) =>{
    return (dispatch) => {
        const request = {
            url: `${OXE_SYNC_URL}/systemconf/${getSessionItem(CC_PRODUCT_ID)}`
           
        }
        getRequest(request , (response, status) => { 
            if (status && response?.responseCode === SUCCESS) {
                dispatch(setOxeSystemConfigData(response))
                dispatch(setContentLoading(false))
            } else {
                console.log(response)
                dispatch(setContentLoading(false))
            }


        })

    }
}

export const getDiscriminationValue = ( url ) => {
    return (dispatch, getState) => {
        const request = {
         url: `${OXE_SYNC_URL}/systemconf/UmcDiscriminator/${getSessionItem(CC_PRODUCT_ID)}`
        }

        getRequest(request, (response, status) => {
            if (status && response.status === SUCCESS) {
                 dispatch(setOxeUmcDiscriminator(response.value))
                 dispatch(setContentLoading(false))
                console.log("response", response)
            } else {
                dispatch(setContentLoading(false))
            }
        })
    }
}

export const updateDiscriminationValue = (payload) => {
    return async (dispatch, getState) => {
        try {
            const response = await fetch(
                `${OXE_SYNC_URL}/systemconf/UmcDiscriminator/${getSessionItem(CC_PRODUCT_ID)}`,
                {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${getSessionItem(TOKEN_2)}`, // if token needed
                    },
                    body: JSON.stringify({
                        value: (payload === false)? 1 : 0
                    }),
                }
            );

            if (!response.ok) {
                throw new Error(`Failed with status ${response.status}`)
            }

            const data = await response.json();
            dispatch(setContentLoading(false))
            return data
        } catch (error) {
            console.error("Error updating discrimination value:", error)
            dispatch(setContentLoading(false))
            throw error
        }
    }
}

//Utitlity to show error popup in case of failure using OXE error codes, need default structure to work
export const showOxeErrorsByCodesInDialog = (response, callback) => {
    return (dispatch, getState) => {
        const store = getState();
        const oxeErrorCodes = store.common.oxeErrorCodes || []
        const dict = store.common.dict || {}

        const errorObj = response?.errorResponse?.[0]
        const hasErrorCodes = oxeErrorCodes && Object.keys(oxeErrorCodes)?.length > 0

        let titleMessage = getTranslated(dict, "LABEL_FAILED")
        let contentMessage = ''

        if (response?.errorResponse?.length) {
            if (hasErrorCodes) {
                const isErrorKeyPresent = oxeErrorCodes[errorObj?.errorKey]
                const isAddlErrorKeyPresent = oxeErrorCodes[errorObj?.addlErrorKey]

                titleMessage = isErrorKeyPresent ? oxeErrorCodes[errorObj?.errorKey] : errorObj?.message ? errorObj?.message : getTranslated(dict, "LABEL_FAILED")
                contentMessage = isAddlErrorKeyPresent ? oxeErrorCodes[errorObj?.addlErrorKey] : ''
            }
        } else {
            console.log('failed')
        }
        confirmModal({
            type: "error",
            title: titleMessage,
            content: contentMessage,
            okText: "LABEL_OK",
            onOk :()=>{
                callback && callback()                    
            }
        })
    }
}
